//
// Copyright (c) 2011-2018 by Curalate, Inc.
//
import _ from 'underscore';

import { HashtagLimitsActionType } from '@hashtag-limits/actions/hashtagLimitsActions';
import { HASHTAG_LIMITS_ACTIONS } from '@hashtag-limits/constants/hashtagLimitsConstants';
import { IHashtagLimits } from '@hashtag-limits/model/hashtagLimitsStateModel';

const initialState: IHashtagLimits = {
  errorMessage: '',
  flags: {
    hashtagsBeingUntracked: [],
    isFetchingHashtagsUsage: false,
    isTrackingHashtag: false,
  },
  isHashtagLimitsModalOpen: false,
  newHashtagName: '',
  trackedHashtags: [],
  otherUsedHashtags: [],
  usedHashtagCount: 0,
};

export default function HashtagLimitsReducer(
    state: IHashtagLimits = initialState,
    action: HashtagLimitsActionType,
) {
  switch (action.type) {
    case HASHTAG_LIMITS_ACTIONS.OPEN_HASHTAG_LIMITS_MODAL: {
      return {
        ...state,
        isHashtagLimitsModalOpen: true,
      };
    }

    case HASHTAG_LIMITS_ACTIONS.CLOSE_HASHTAG_LIMITS_MODAL: {
      return {
        ...state,
        isHashtagLimitsModalOpen: false,
      };
    }
    case HASHTAG_LIMITS_ACTIONS.SET_NEW_HASHTAG_NAME: {
      return {
        ...state,
        newHashtagName: action.newHashtagName,
        errorMessage: '',
      };
    }
    case HASHTAG_LIMITS_ACTIONS.REQUEST_HASHTAGS_USAGE: {
      return {
        ...state,
        flags: {
          ...state.flags,
          isFetchingHashtagsUsage: true,
        },
      };
    }
    case HASHTAG_LIMITS_ACTIONS.RECEIVE_HASHTAGS_USAGE_SUCCEEDED: {
      return {
        ...state,
        flags: {
          ...state.flags,
          isFetchingHashtagsUsage: false,
        },
        trackedHashtags: action.trackedHashtags,
        otherUsedHashtags: action.otherUsedHashtags,
        usedHashtagCount: action.usedHashtagCount,
      };
    }
    case HASHTAG_LIMITS_ACTIONS.RECEIVE_HASHTAGS_USAGE_FAILED: {
      return {
        ...state,
        errorMessage: action.message,
        flags: {
          ...state.flags,
          isFetchingHashtagsUsage: false,
        },
      };
    }
    case HASHTAG_LIMITS_ACTIONS.REQUEST_TRACK_NEW_HASHTAG: {
      return {
        ...state,
        flags: {
          ...state.flags,
          isTrackingHashtag: true,
        },
      };
    }
    case HASHTAG_LIMITS_ACTIONS.RECEIVE_TRACK_NEW_HASHTAG_SUCCEEDED: {
      return {
        ...state,
        flags: {
          ...state.flags,
          isTrackingHashtag: false,
        },
      };
    }
    case HASHTAG_LIMITS_ACTIONS.RECEIVE_TRACK_NEW_HASHTAG_FAILED: {
      return {
        ...state,
        errorMessage: action.message,
        flags: {
          ...state.flags,
          isTrackingHashtag: false,
        },
      };
    }
    case HASHTAG_LIMITS_ACTIONS.REQUEST_UNTRACK_HASHTAG: {
      return {
        ...state,
        flags: {
          ...state.flags,
          hashtagsBeingUntracked: [...state.flags.hashtagsBeingUntracked, action.hashtag],
        },
      };
    }
    case HASHTAG_LIMITS_ACTIONS.RECEIVE_UNTRACK_HASHTAG_SUCCEEDED: {
      const hashtagsBeingUntracked = _(state.flags.hashtagsBeingUntracked).without(action.hashtag);

      return {
        ...state,
        flags: {
          ...state.flags,
          hashtagsBeingUntracked,
        },
      };
    }
    case HASHTAG_LIMITS_ACTIONS.RECEIVE_UNTRACK_HASHTAG_FAILED: {
      const hashtagsBeingUntracked = _(state.flags.hashtagsBeingUntracked).without(action.hashtag);

      return {
        ...state,
        errorMessage: action.message,
        flags: {
          ...state.flags,
          hashtagsBeingUntracked,
        },
      };
    }
    default:
      return state;
  }
}
